import { Typography } from "@/components";
import type { Bulletin } from "@/types";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import dayjs from "dayjs";

interface BulletinCardProps {
	bulletin: Bulletin;
}

const BulletinCard = (props: BulletinCardProps) => {
	const { bulletin } = props;

	return (
		<Card
			variant="outlined"
			className="!rounded-xl !h-32 !p-4 flex flex-col justify-between"
		>
			<div className="flex flex-row gap-4">
				<CardContent
					className="!flex-1 !flex !flex-col !justify-center !items-start"
					sx={{ p: 0 }}
				>
					<Typography
						fontWeight={600}
						fontSize={12}
						className="text-primary text-pretty line-clamp-1"
					>
						{bulletin.title}
					</Typography>
					{bulletin.description ? (
						<Typography
							fontWeight={400}
							fontSize={12}
							className="text-pretty line-clamp-2"
						>
							{bulletin.description}
						</Typography>
					) : null}
					{bulletin.link ? (
						<a href={bulletin.link} target="_blank" rel="noopener noreferrer">
							<Typography
								fontWeight={400}
								fontSize={12}
								className="text-primary/75 line-clamp-1"
							>
								{bulletin.link}
							</Typography>
						</a>
					) : null}
				</CardContent>
				{bulletin.image_url && bulletin.type !== "file" ? (
					<CardMedia
						component="img"
						sx={{ width: 80, height: 80, borderRadius: 2 }}
						image={bulletin.image_url}
						alt={bulletin.title ?? bulletin.image_url}
					/>
				) : bulletin.type === "file" ? (
					<Avatar
						variant="rounded"
						className="!bg-gray-light !text-primary !h-20 !w-20"
					>
						<DescriptionOutlinedIcon className="!text-[3rem]" />
					</Avatar>
				) : null}
			</div>
			<div className="flex items-center justify-end py-1">
				<Typography
					fontWeight={400}
					fontSize={12}
					className="text-pretty line-clamp-1 w-20 text-center"
				>
					{dayjs(bulletin.updated_at).format("DD MMM YYYY")}
				</Typography>
			</div>
		</Card>
	);
};

export default BulletinCard;
